import { AbstractComponentPropTypes } from '../../../cms/registries';
import { ImageDefination, LinkDefination } from '../../types/common';
import { ThemeColorType } from '../../../utils/themeColor';

export interface Images {
  title: string;
  subTitle: string;
  backgroundColor: string;
  overlayGradient?: GradientType;
  linearGradient?: ThemeColorType;
  redirectionInfo: LinkDefination;
  imageList: ImageDefination[];
}

interface HeroBannerProps extends AbstractComponentPropTypes {
  images: Images[];
}

type GradientType = keyof typeof Gradient;

enum Gradient {
  blue = 'blue-gradient',
  maroon = 'maroon-gradient',
  red = 'red-gradient',
  orange = 'orange-gradient',
  green = 'green-gradient',
  purple = 'purple-gradient',
}

export default HeroBannerProps;
export { Gradient, GradientType };
